import {
  BooleanInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required,
  SelectInput
} from 'react-admin';
import { UploadImageInput } from '../../components';

export default function SlidesForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        autoComplete="off"
        fullWidth
        label="Título"
        source="title"
        validate={[required()]}
      />

      <TextInput
        autoComplete="off"
        fullWidth
        label="Identificador/Slug"
        source="slug"
        validate={[required()]}
      />

      <TextInput
        autoComplete="off"
        fullWidth
        label="Descrição"
        source="description"
        validate={[required()]}
      />

      <UploadImageInput
        cropOptions={{ aspectRatio: 1920 / 864 }}
        fullWidth
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de 1920x864px."
        label="Imagem desktop"
        upploadOptions={{
          maxSize: [1920, 864]
        }}
        mimeTypes={['image/jpeg']}
        source="desktopImage"
        validate={[required()]}
      />

      <UploadImageInput
        cropOptions={{ aspectRatio: 390 / 548 }}
        fullWidth
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de 390x548px."
        label="Imagem mobile"
        upploadOptions={{
          maxSize: [390, 548]
        }}
        mimeTypes={['image/jpeg']}
        source="mobileImage"
        validate={[required()]}
      />

      <UploadImageInput
        cropOptions={{ aspectRatio: 1 }}
        fullWidth
        helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de 106x106px."
        label="Miniatura"
        upploadOptions={{
          maxSize: [106, 106]
        }}
        mimeTypes={['image/jpeg']}
        source="thumbnail"
        validate={[required()]}
      />

      <TextInput autoComplete="off" fullWidth label="Link" source="link" />

      <SelectInput
        choices={[
          { id: '_self', name: 'Mesma janela' },
          { id: '_blank', name: 'Nova aba' }
        ]}
        label="Abrir em"
        source="target"
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
